export default __webpack_public_path__ + "static/media/minivistaw-invierteencapacitacion.b334ff5a.jpg";